import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Analytics from '@vercel/analytics';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { initializeAnalytics } from './utils/analytics';
import HomePage from './pages/HomePage';
import PKCurve from './pages/PKCurve';
import NavBar from './components/NavBar';
import FeedbackWidget from './components/FeedbackWidget';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import LogDosePage from './pages/LogDosePage';
import CostAnalysisPage from './pages/CostAnalysisPage';
import AdminPricingPage from './pages/AdminPricingPage';
import AdminUserManagementPage from './pages/AdminUserManagementPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminEmailCampaignsPage from './pages/AdminEmailCampaignsPage';
import AdminRedditMarketingPage from './pages/AdminRedditMarketingPage';
import SettingsPage from './pages/SettingsPage';
import WeightPage from './pages/WeightPage';
import SymptomsPage from './pages/SymptomsPage';
import ExportPage from './pages/ExportPage';
import JourneyDashboardPage from './pages/JourneyDashboardPage';

function AppContent() {
  const { isAuthenticated, userType } = useAuth();
  
  // Initialize analytics when app loads
  useEffect(() => {
    initializeAnalytics();
  }, []);
  
  return (
    <Router>
      <NavBar />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/calculator" element={<HomePage />} />
        <Route path="/pk-curve" element={<PKCurve />} />
        <Route path="/weight" element={<WeightPage />} />
        <Route path="/symptoms" element={<SymptomsPage />} />
        <Route path="/export" element={<ExportPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        
        {/* Protected Routes */}
        <Route path="/dashboard" element={<JourneyDashboardPage />} />
        <Route path="/log-dose" element={<LogDosePage />} />
        <Route path="/cost-savings" element={<CostAnalysisPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        
        {/* Admin Routes */}
        <Route path="/admin" element={
          isAuthenticated && userType === 'admin' ? (
            <AdminDashboardPage />
          ) : (
            <div className="p-8 text-center text-red-600">Access denied. Admins only.</div>
          )
        } />
        <Route path="/admin/pricing" element={
          isAuthenticated && userType === 'admin' ? (
            <AdminPricingPage />
          ) : (
            <div className="p-8 text-center text-red-600">Access denied. Admins only.</div>
          )
        } />
        <Route path="/admin/users" element={
          isAuthenticated && userType === 'admin' ? (
            <AdminUserManagementPage />
          ) : (
            <div className="p-8 text-center text-red-600">Access denied. Admins only.</div>
          )
        } />
        <Route path="/admin/email-campaigns" element={
          isAuthenticated && userType === 'admin' ? (
            <AdminEmailCampaignsPage />
          ) : (
            <div className="p-8 text-center text-red-600">Access denied. Admins only.</div>
          )
        } />
        <Route path="/admin/reddit-marketing" element={
          isAuthenticated && userType === 'admin' ? (
            <AdminRedditMarketingPage />
          ) : (
            <div className="p-8 text-center text-red-600">Access denied. Admins only.</div>
          )
        } />
      </Routes>
      {/* DOS-38: feedback widget on every authenticated page */}
      {isAuthenticated && <FeedbackWidget />}
      {/* <Analytics /> */}
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
